import { Configuration } from './generated/configuration'
import {
  UsersApi,
  PartnersApi,
  MerchantsApi,
  APIKeysApi,
  AuditApi,
  AuthenticationApi,
  GatewayConfigurationsApi,
  ValidationsApi,
  WebhooksApi,
  WebhookEventsApi,
  WebhookMonitoringApi,
  WebhookAnalyticsApi,
  WebhookTestingApi,
  PaymentReportingApi,
} from './generated/api'
import { api } from './api'

// Create configuration with auth interceptor
const createConfig = (): Configuration => {
  return new Configuration({
    basePath: import.meta.env.VITE_API_URL || 'http://localhost:8080',
    baseOptions: {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  })
}

// Create authenticated API instances
export const usersApi = new UsersApi(createConfig(), undefined, api)
export const partnersApi = new PartnersApi(createConfig(), undefined, api)
export const merchantsApi = new MerchantsApi(createConfig(), undefined, api)
export const apiKeysApi = new APIKeysApi(createConfig(), undefined, api)
export const auditApi = new AuditApi(createConfig(), undefined, api)
export const authenticationApi = new AuthenticationApi(createConfig(), undefined, api)
export const gatewayConfigurationsApi = new GatewayConfigurationsApi(createConfig(), undefined, api)
export const validationsApi = new ValidationsApi(createConfig(), undefined, api)
export const partnerWebhooksApi = new WebhooksApi(createConfig(), undefined, api)
export const webhookEventsApi = new WebhookEventsApi(createConfig(), undefined, api)
export const webhookMonitoringApi = new WebhookMonitoringApi(createConfig(), undefined, api)
export const webhookAnalyticsApi = new WebhookAnalyticsApi(createConfig(), undefined, api)
export const webhookTestingApi = new WebhookTestingApi(createConfig(), undefined, api)
export const paymentReportingApi = new PaymentReportingApi(createConfig(), undefined, api)

// Export a unified interface for backward compatibility
export const authenticatedApi = {
  users: usersApi,
  partners: partnersApi,
  merchants: merchantsApi,
  apiKeys: apiKeysApi,
  audit: auditApi,
  authentication: authenticationApi,
  gatewayConfigurations: gatewayConfigurationsApi,
  validations: validationsApi,
  webhooks: partnerWebhooksApi,
  webhookEvents: webhookEventsApi,
  webhookMonitoring: webhookMonitoringApi,
  webhookAnalytics: webhookAnalyticsApi,
  webhookTesting: webhookTestingApi,
  paymentReporting: paymentReportingApi,
}
